module.exports = __webpack_public_path__ + "static/img/avatar.1d88924.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avatar.png
// module id = zQrT
// module chunks = 0